import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Zona } from '../shared/zona.model';
import { FabButtonGroupComponent } from 'src/app/shared/fabbuttongroup/fabbuttongroup.component';
import { LoaderService, NotificationService, TOOLTIPS, ICONS, ACTIONS, EVENTO } from 'src/app/shared/session';
import { ZonaService } from '../shared/zona.service';

@Component({
  selector: 'app-zona-save',
  templateUrl: './zona-save.component.html',
})
export class ZonaSaveComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGroupZona: FormGroup;
  msgErrorGuardar: string;
  obligatorioMsg: string;
  zona: Zona;
  buttonGroup: any;
  @ViewChild(FabButtonGroupComponent) fabButtonGroupComponent: FabButtonGroupComponent;

  constructor(
    public fb: FormBuilder,
    private loaderService: LoaderService,
    private zonaService: ZonaService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.initData();
  }

  async initData() {
    this.msgErrorGuardar = 'Error al guardar zona';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.zona = new Zona();
    this.setValuesFormBuilder();
    if (this.data != null && this.data.zona != null && this.data.zona.id != null) {
      this.zona = await this.zonaService.obtenerZona(this.data.zona.id).toPromise();
      this.setValuesFormBuilder();
    }
  }

  setValuesFormBuilder() {
    this.formGroupZona = this.fb.group({
      nombre: [this.zona.nombre, Validators.compose([Validators.required])],
    });
  }

  formGroupZonaSubmit(event) {
    if (this.formGroupZona.invalid)
      return;
    if (this.fabButtonGroupComponent.disabled) return;
    this.fabButtonGroupComponent.disabled = true;
    this.zona.nombre = event.value.nombre;
    this.guardarZona();
  }

  async guardarZona() {
    this.loaderService.show();
    try {
      if (this.data != null && this.data.zona != null && this.data.zona.id != null) {
        await this.zonaService.actualizarZona(this.zona).toPromise();
        this.notificationService.successful("Zona actualizada con éxito");
      } else {
        let id = await this.zonaService.insertarZona(this.zona).toPromise();
        this.zona.id = id;
        this.notificationService.successful("Zona registrada con éxito");
      }
      this.data.zona = { id: this.zona.id };
      this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    } catch (error) {
      this.notificationService.error(this.msgErrorGuardar);
      throw error;
    } finally {
      this.loaderService.hide();
      this.fabButtonGroupComponent.disabled = false;
    }
  }
}
